import { useProjectActions, useProjectContext } from "@contexts/projects";
import { downloadCsv } from "@utils/downloadCsv";
import { ensureDateType } from "@utils/formatDate";
import { useCallback, useEffect, useState } from "react";

const formatDateToInput = (value) => {
  const date = ensureDateType(value);
  return date.toISOString().slice(0, 7);
}

const formatInputToDate = (value) => {
  const [year, month] = value.split("-");
  return new Date(Date.UTC(year, month - 1, 1))
}

const OffCanvasDateFilter = ({ refreshGraph = true }) => {
  const { selectedDetail: { item }, offCanvasFilterDates, graphMaxDates } = useProjectContext();
  const { changeGraphDates } = useProjectActions();

  const changeStart = useCallback(({ target: { value } }) => {
    if (value.length <= 0) return;
    const startDate = formatInputToDate(value);
    changeGraphDates(
      item.wbs_code_id,
      startDate,
      offCanvasFilterDates.endAt,
      { refreshGraph },
    )
  }, [item, offCanvasFilterDates.endAt, refreshGraph])

  const changeEnd = useCallback(({ target: { value } }) => {
    if (value.length <= 0) return;
    const endDate = formatInputToDate(value);
    changeGraphDates(
      item.wbs_code_id,
      offCanvasFilterDates.beginAt,
      endDate,
      { refreshGraph },
    )
  }, [item, offCanvasFilterDates.beginAt, refreshGraph])

  return <form className="date-range" style={{ justifyContent: 'end' }}>
    <input
      type="month"
      required={true}
      min={formatDateToInput(graphMaxDates.begin)}
      max={formatDateToInput(offCanvasFilterDates.endAt)}
      value={formatDateToInput(offCanvasFilterDates.beginAt)}
      onChange={changeStart}
    />
    <span className="color-gray">-</span>
    <input
      type="month"
      required
      min={formatDateToInput(offCanvasFilterDates.beginAt)}
      max={formatDateToInput(graphMaxDates.end)}
      value={formatDateToInput(offCanvasFilterDates.endAt)}
      onChange={changeEnd}
    />
  </form>
};

export default OffCanvasDateFilter;
